import React from "react";
import {getInitials} from "../../utils/general.js";

import './UserAvatar.scss';

const UserAvatar = props => {
	const {name} = props;

	return (
		<div className="avatar-container">
			{getInitials(name)}
		</div>
	)
};

export default UserAvatar;

